export default "__VITE_ASSET__Bc5qTYpx__"